/**
 * @author Harish.R <harish.r@314ecorp.com>
 * constants for subscriptions
 */

const STRIPE_PAYMENT_STATUSES = {
	success: {
		value: 'succeeded',
		label: 'Paid',
		color: 'green',
	},
	failure: {
		value: 'failed',
		label: 'Payment Failed',
		color: 'red',
	},
	pending: {
		value: 'pending',
		label: 'Pending',
		color: 'yellow',
	},
	unknown: {
		value: 'unknown',
		label: 'Unknown',
		color: 'gray',
	},
};

const PLAN_PERIODS = {
	monthly: {
		value: 'monthly',
		pricingLabel: 'month',
		radioLabel: 'Monthly Billing',
	},
	yearly: {
		value: 'yearly',
		pricingLabel: 'year',
		radioLabel: 'Yearly Billing',
	},
};

const ADDON_STATUSES = {
	enabled: 1 as Subscriptions.IAddOnStatus,
	disabled: 0 as Subscriptions.IAddOnStatus,
	cancelled: -1 as Subscriptions.IAddOnStatus,
};

const SUBSCRIPTIONS_TABS = {
	plan: {
		key: 'plan',
		label: 'Plan Details',
	},
	addon: {
		key: 'addon',
		label: 'Add-On',
	},
	invoice: {
		key: 'invoice',
		label: 'Payment and Invoices',
	},
};

const CHARGES_CODE = 'default_batch';

const ADDON_CODES: Record<'payments', Subscriptions.IAddOnCodes> = { payments: 'a_payments' };

export { STRIPE_PAYMENT_STATUSES, PLAN_PERIODS, ADDON_STATUSES, CHARGES_CODE, ADDON_CODES, SUBSCRIPTIONS_TABS };
